import orderBy from 'lodash/orderBy';

import { EnhancedItem } from '../../hooks/useEnhancedItems';

/**
 * Sorts enhanced items to show selected items first.
 * Select All items always stay at the top.
 */
export const sortSelectedItemsToTheTop = <Item>(
  items: EnhancedItem<Item>[]
): EnhancedItem<Item>[] => {
  // Separate select all items (always at the top)
  const selectAllItem = items.filter((item) => item.itemType === 'selectAll');
  const nonSelectAllItems = items.filter(
    (item) => item.itemType !== 'selectAll'
  );

  const sortedRegularItems = orderBy(
    nonSelectAllItems,
    [(item): boolean => item.isSelected],
    ['desc']
  );
  return [...selectAllItem, ...sortedRegularItems];
};
